import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import { Box, TextField, Typography, IconButton } from '@mui/material';
import { PromoResultType } from 'src/pages/PromoResultPage';
import InputBoxOnChange from '../inputbox/InputBoxOnChange';
import { usePromoresultStore } from 'src/stores/PromoStore';
import DatePickerPromoResult from './DatePickerPromoResult';
import { AlertSpan, NextButton } from '../common/CommonStyled';
import { promoResultType } from 'src/types/PromoType';
import ButtonResultModify from './ButtonResultModify';
import Icon_Trash from 'src/assets/images/Icon_Trash.svg'
import { deletePromotion } from 'src/api/Promo';
import { Icon_ArrowBack } from '../common/CommonIcons';
import { useDialogStore } from 'src/stores/DialogStore';
import { toast } from 'react-toastify';
import { useModalStore } from 'src/stores/ModalStore';
import { ModalContentDelete, ModalFooterDelete, ModalTitleDelete } from './ModalFieldsPromoResult';

interface Props{
  setTab : React.Dispatch<React.SetStateAction<PromoResultType>>;
  currentPromotion: promoResultType | undefined
  ;
}

const Container = styled(Box)`
  padding: 20px;
  max-width: 600px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100vh;
  ;
`;

const Label = styled(Typography)({
  color: '#7F7F89',
  fontSize: '14px',
  paddingBottom: '10px'
})

const NumberInputContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  marginTop: '10px'
})

const LargeTextField = styled(TextField)`
  height: '100%';
`;

const ButtonContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-Top:20px;
  gap: 10px;
  width: 100%;
`;

const Header = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center', // ✅ camelCase로 수정
  paddingBottom: '32px',
  fontSize:'18px',
  fontWeight:'bold'
});

const PromoResultModify = ({setTab, currentPromotion}:Props) => {
  const setField = usePromoresultStore((state)=>state.setField)
  const reset = usePromoresultStore((state)=>state.reset)
  const school_class = currentPromotion?.school?.education_class === '고등학교' ? 'high' : currentPromotion?.school?.education_class === '대학교' ? 'univ':'etc'
  const [name,setName] = useState('')
  const [total_cnt,setTotal_cnt] = useState(currentPromotion?.total_cnt.toString())
  const [attendee_cnt,setAttendee_cnt] = useState(currentPromotion?.attendee_cnt.toString())
  const [memo,setMemo] = useState(currentPromotion?.content)
  const setFieldDialog = useDialogStore((state)=>state.setField)
  const modalSetField = useModalStore((state)=>state.setField)
  const setAcceptAction = useModalStore((state)=>state.setAcceptAction)

  const isAttendeeValid = (Number(total_cnt)>=Number(attendee_cnt)) ? true:false

  // currentPromotion이 변할 때마다 name도 업데이트
  useEffect(() => {
    if (currentPromotion?.school) {
      setName(currentPromotion.school.school_name);
    } else {
      setName('');
    }
  }, [currentPromotion]);


  useEffect(()=>{
    return ()=>{
      reset()
    }
  //eslint-disable-next-line
  },[])

  useEffect(()=>{
    setField('school_name',name)
  //eslint-disable-next-line
  },[name])
  useEffect(()=>{
    setField('total_cnt',total_cnt)
  //eslint-disable-next-line
  },[total_cnt])
  useEffect(()=>{
    setField('attendee_cnt',attendee_cnt)
  //eslint-disable-next-line
  },[attendee_cnt])
  useEffect(()=>{
    setField('content',memo)
  //eslint-disable-next-line
  },[memo])

  const handleName = (e:React.ChangeEvent<HTMLInputElement>)=>{
    setName(e.target.value)
  }

  const handleTotal_Cnt = (e:React.ChangeEvent<HTMLInputElement>)=>{
    setTotal_cnt(e.target.value)
    setField('total_cnt',e.target.value)
  }

  const handleAttendee_Cnt = (e:React.ChangeEvent<HTMLInputElement>)=>{
    setAttendee_cnt(e.target.value)
    setField('attendee_cnt',e.target.value)
  }

  const handleMemo = (e:React.ChangeEvent<HTMLInputElement>)=>{
    setMemo(e.target.value)
    setField('content',e.target.value)
  }

  const handleDelete = async ()=>{
    const response = await deletePromotion(currentPromotion!.result_id,school_class)
    setFieldDialog('response_data',[])
    setFieldDialog('page_Num',1)
    setTab('home')
    if (response.status === 'OK') modalSetField('open',false)
    else{
      modalSetField('open',false)
      toast.error('삭제실패',{autoClose:2000})
    }
  }

  const onClickDelete = ()=>{
      modalSetField('type','CENTER')
      modalSetField('padding','24px')
      modalSetField('width','calc(100vw - 40px)')
      modalSetField('title',ModalTitleDelete)
      modalSetField('content',ModalContentDelete)
      modalSetField('footer',<ModalFooterDelete/>)
      modalSetField('open',true)
      setAcceptAction(handleDelete)
    }
  return (
    <Container>
      <Header>
        <IconButton onClick={() => setTab('home')} sx={{position:'absolute',left:'10px'}}>
          <Icon_ArrowBack/>
        </IconButton>
        홍보 결과 수정
        <IconButton onClick={onClickDelete} sx={{position:'absolute',right:'20px'}}>
          <img src={Icon_Trash} alt="" />
        </IconButton>
      </Header>
      <Label>*학교명</Label>
        <Box display="flex" alignItems="baseline" justifyContent="flex-end">
          <InputBoxOnChange onChange={handleName} value={name} disabled={true}/>
        </Box>
      <Label marginTop='10px'>*방문일자</Label>
        <DatePickerPromoResult dateProps={currentPromotion?.visit_date}/>
      <Label marginTop='10px'>인원</Label>
      <NumberInputContainer>
        <Label minWidth='110px'>*전체 학생</Label>
        <Box display="flex" alignItems="baseline" justifyContent="flex-end" flex="1">
          <InputBoxOnChange onChange={handleTotal_Cnt} value={total_cnt}/>
          <Label paddingLeft='10px'>명</Label>
        </Box>
      </NumberInputContainer>
      <NumberInputContainer>
        <Label minWidth='110px'>*참여자</Label>
        <Box display="flex" alignItems="baseline" justifyContent="flex-end" flex="1">
          <InputBoxOnChange onChange={handleAttendee_Cnt} value={attendee_cnt} isValid={isAttendeeValid}/>
          <Label paddingLeft='10px'>명</Label>
        </Box>
      </NumberInputContainer>
        {Number(attendee_cnt) !== 0 &&
          (isAttendeeValid ? 
            <></>
            :
            <AlertSpan $isValid={false}>참여자 수가 전체 학생 수보다 많습니다.</AlertSpan>
          )
        }
      <Box flex={1} display='flex'flexDirection={'column'}>
      <Label>메모</Label>
      <LargeTextField fullWidth onChange={handleMemo} multiline rows={7} placeholder=""  value={memo}/>
      </Box>
      <ButtonContainer>
        <NextButton style={{background:'#F5F5F5', color:'#7F7F89', minWidth:'90px', width:'90px'}} onClick={() => setTab('home')}>취소</NextButton>
        <ButtonResultModify school_class={school_class} result_id={currentPromotion!.result_id} setTab={setTab}/>
      </ButtonContainer>
    </Container>
  ); 
};

export default PromoResultModify;